import { AxiosError } from 'axios';

export const isAxiosError = (error: unknown): error is AxiosError => {
  return error instanceof Error && (error as AxiosError).isAxiosError !== undefined;
}